import { useOpportunity } from "@repo/api";
import { AccordionItem, ListView, Skeleton, Text } from "@repo/skapa";
import { t } from "@repo/translation";
import { ElementsContainer } from "@repo/ui";

import { ProjectDetailsItem } from "./ProjectDetailsSection";
import { ProjectDetailsTabs } from "./ProjectDetailsTabs";

export const ProjectQuickInfo = ({
  projectId,
  showTabs,
}: {
  projectId?: number;
  showTabs?: boolean;
}) => {
  const { data: opportunity, isValidating: isValidatingOpportunity } =
    useOpportunity(projectId);

  return (
    <AccordionItem
      id="project-details"
      title={t("label.project_details")}
      open={true}
    >
      {isValidatingOpportunity ? (
        <Skeleton height="52px" />
      ) : opportunity ? (
        <ElementsContainer>
          <ListView
            id="calendar-appointment-modal__project-details"
            showDivider={showTabs}
          >
            <ProjectDetailsItem opportunity={opportunity} showProjectId />
          </ListView>

          {showTabs && <ProjectDetailsTabs opportunity={opportunity} />}
        </ElementsContainer>
      ) : (
        <Text>{t("prompt.no_project_detail")}</Text>
      )}
    </AccordionItem>
  );
};
